
export const name = "marketplace-assets-app-ui";
export const version = "dev";
